/* Keep Selleasy's nodes and event handlers intact; enhance layout and savings. */
(() => {
  if (window.herbamamaFbtLayout) return;
  window.herbamamaFbtLayout = true;

  // Capture the click before the app handles it, without changing its action.
  // Delegation also covers buttons inserted or replaced by Selleasy.
  const buttonSelector = '.selleasy-block-fbt .ppcse-tot-btn-div.lb-upsell-tot-btn';
  const pendingButtons = new Map();
  const buttonState = (button) => JSON.stringify([
    button.innerHTML,
    ...['class', 'style', 'aria-busy', 'aria-disabled', 'disabled'].map((name) => button.getAttribute(name)),
  ]);
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.(buttonSelector);
    if (!button || pendingButtons.has(button)) return;
    pendingButtons.set(button, { initial: buttonState(button), changed: false });
    button.setAttribute('data-hm-clicked', '');
  }, true);
  // Pointer movement must not restore hover while the app is still loading.
  // Restore it only when the app returns the button to its pre-click markup.
  new MutationObserver(() => {
    pendingButtons.forEach((state, button) => {
      if (!button.isConnected) {
        pendingButtons.delete(button);
        return;
      }
      if (buttonState(button) !== state.initial) {
        state.changed = true;
      } else if (state.changed) {
        button.removeAttribute('data-hm-clicked');
        pendingButtons.delete(button);
      }
    });
  }).observe(document.body, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'aria-busy', 'aria-disabled', 'disabled'],
  });

  const readPrice = (element) => {
    if (!element) return NaN;
    const text = element.textContent.replace(/[^\d.,-]/g, '');
    if (!text) return NaN;
    // Read the displayed currency amount, including decimal-comma formats.
    const decimal = text.match(/[.,](\d{2})$/);
    const normalized = decimal
      ? text.slice(0, decimal.index).replace(/[.,]/g, '') + '.' + decimal[1]
      : text.replace(/[.,]/g, '');
    return Math.round(Number(normalized) * 100);
  };

  const updateSavings = (grid) => {
    const savings = grid.querySelector('.ppcse-tot-container-bundle-c');
    if (!savings) return;
    const full = readPrice(grid.querySelector('.ppcse-card-tot-price-strike-out'));
    const sale = readPrice(grid.querySelector('.ppcse-card-tot .lb-upsell-sale-price'));
    if (!Number.isFinite(full) || !Number.isFinite(sale) || full < sale) {
      savings.removeAttribute('data-hm-savings');
      return;
    }
    const currency = window.Shopify?.currency?.active || 'USD';
    const amount = ((full - sale) / 100).toFixed(2).replace('.', ',');
    const label = `You save ${amount}${currency === 'USD' ? '$' : ` ${currency}`}`;
    if (savings.getAttribute('data-hm-savings') !== label) {
      savings.setAttribute('data-hm-savings', label);
    }
  };

  const update = () => {
    document.querySelectorAll('.selleasy-block-fbt .ppcse-card-lt-cont').forEach((grid) => {
      const cards = [...grid.children].filter((node) => node.matches('.lb-upsell-product-page-card'));
      if (!cards.length) return;
      grid.style.setProperty('--fbt-count', cards.length);
      grid.style.setProperty('--fbt-summary-column', cards.length + 1);
      grid.style.setProperty('--fbt-action-column', cards.length + 2);
      grid.style.setProperty('--fbt-button-row', cards.length + 4);
      cards.forEach((card, index) => {
        card.style.setProperty('--fbt-column', index + 1);
        card.style.setProperty('--fbt-row', index + 3);
        card.style.setProperty('--fbt-mobile-row', index + 4);
      });
      grid.classList.add('hm-fbt-grid');
      updateSavings(grid);
    });
  };

  let queued = false;
  new MutationObserver((records) => {
    if (!records.some((record) => {
      const element = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      return element?.closest('.selleasy-block-fbt') ||
        [...record.addedNodes].some((node) => node.nodeType === 1 &&
          (node.matches('.selleasy-block-fbt') || node.querySelector('.selleasy-block-fbt')));
    })) return;
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      update();
    });
  }).observe(document.body, { childList: true, characterData: true, subtree: true });
  update();
})();
